export default [
  { id: 1, name: 'Web', displayName: 'Web', description: 'Web' },
  { id: 2, name: 'Mobile', displayName: 'Mobile', description: 'Mobile' },
  { id: 3, name: 'Kiosk', displayName: 'Kiosk', description: 'Kiosk' }
];
